// extracted by mini-css-extract-plugin
module.exports = {"fab":"Navigation_fab__tYXIV","fas":"Navigation_fas__SCbPm","light":"Navigation_light__3bFu1","dark":"Navigation_dark__1RxPR"};